import { t } from '@lingui/core/macro';
import { MetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const liabilityCapScopeFilterLabel = () => t({ message: 'Liability cap scope', comment: 'Insights filter: Liability cap scope' });
export function LiabilityCapScopeFilter() {
    return (<MetadataAllowedValuesFilter name="LiabilityCapScope" field="metadataDocumentLiabilityCapScope" label={liabilityCapScopeFilterLabel()}/>);
}
